module.exports = __webpack_public_path__ + "static/img/VDproduct3.a51c93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VDproduct3.png
// module id = Plwl
// module chunks = 0